// Constants for listing gift cards
export const LIST_GIFTCARDS_REQUEST = "LIST_GIFTCARDS_REQUEST";
export const LIST_GIFTCARDS_SUCCESS = "LIST_GIFTCARDS_SUCCESS";
export const LIST_GIFTCARDS_FAIL = "LIST_GIFTCARDS_FAIL";

// constants/giftCardConstants.js
export const CREATE_GIFTCARD_REQUEST = "CREATE_GIFTCARD_REQUEST";
export const CREATE_GIFTCARD_SUCCESS = "CREATE_GIFTCARD_SUCCESS";
export const CREATE_GIFTCARD_FAIL = "CREATE_GIFTCARD_FAIL";
export const CREATE_GIFTCARD_RESET = "CREATE_GIFTCARD_RESET";

export const DELETE_GIFTCARD_REQUEST = "DELETE_GIFTCARD_REQUEST";
export const DELETE_GIFTCARD_SUCCESS = "DELETE_GIFTCARD_SUCCESS";
export const DELETE_GIFTCARD_FAIL = "DELETE_GIFTCARD_FAIL";
export const DELETE_GIFTCARD_RESET = "DELETE_GIFTCARD_RESET";

export const UPDATE_GIFTCARD_REQUEST = "UPDATE_GIFTCARD_REQUEST";
export const UPDATE_GIFTCARD_SUCCESS = "UPDATE_GIFTCARD_SUCCESS";
export const UPDATE_GIFTCARD_FAIL = "UPDATE_GIFTCARD_FAIL";
export const UPDATE_GIFTCARD_RESET = "UPDATE_GIFTCARD_RESET";




export const PURCHASE_GIFTCARD_REQUEST = "PURCHASE_GIFTCARD_REQUEST";
export const PURCHASE_GIFTCARD_SUCCESS = "PURCHASE_GIFTCARD_SUCCESS";
export const PURCHASE_GIFTCARD_FAIL = "PURCHASE_GIFTCARD_FAIL";

export const GET_GIFT_CARD_DETAILS_REQUEST = "GET_GIFT_CARD_DETAILS_REQUEST";
export const GET_GIFT_CARD_DETAILS_SUCCESS = "GET_GIFT_CARD_DETAILS_SUCCESS";
export const GET_GIFT_CARD_DETAILS_FAIL = "GET_GIFT_CARD_DETAILS_FAIL";

